import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Typography,
  Input,
  Button,
  List,
  Row,
  Col,
  Checkbox,
  message,
  Select,
  Switch,
  Pagination,
  Spin,
  DatePicker,
  Drawer,
  Carousel,
  Image,
  Radio
} from "antd";
import moment from "moment";

import { AiOutlineMessage } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa";
import { Image as AntdImage } from "antd";

import dataService from "../networks/api/service/dataService";
import { useLocation } from "react-router-dom";
import template1 from "../assets/images/template1.png";
import template2 from "../assets/images/template2.jpg";
import template3 from "../assets/images/template3.jpg";
import template4 from "../assets/images/template4.jpg";
import colors from "../assets/styles/colour";
import { color } from "framer-motion";

const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

const SendMessage = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedVoters, setSelectedVoters] = useState([]);
  const [selectAll, setselectAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [emailHeader, setEmailHeader] = useState("");
  const [messages, setMessages] = useState("");
  const [constituencyList, setConstituencyList] = useState([]);
  const [assemblyList, setAssemblyList] = useState([]);
  const [panchayatList, setPanchayatList] = useState([]);
  const [boothList, setBoothList] = useState([]);
  const [assemblyId, setAssemblyId] = useState("");
  const [panchayatId, setPanchayatId] = useState("");
  const [boothId, setBoothId] = useState("");
  const [constituencyId, setConstituencyId] = useState("");
  const [isInfluencer, setIsInfluencer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [skip, setskip] = useState(0);
  const [limit, setlimit] = useState(10);
  const [electionType, setelectionType] = useState("");
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const [templateMessage, setTemplateMessage] = useState("");
  const [currentTemplateIndex, setCurrentTemplateIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [messageMode, setMessageMode] = useState("email"); // 'email' or 'mobile'
  const [mobileNumber, setMobileNumber] = useState("");
  const [UserMessage, setUserMessage] = useState("");
  const canvasRef = useRef(null);

  const [visible, setVisible] = useState(false); // Controls the visibility of the drawer
  const [dob, setDob] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    influencers: false,
    voters: false,
    dob: false,
    hof: false,
  });

  const carouselRef = useRef(null);

  const [isTemplateMode, setIsTemplateMode] = useState(false);




  useEffect(() => {
 setMobileNumber("")
 setEmailHeader("")
    setUserMessage("");
  }, [messageMode])
  
  const templateImages = [
    {
      src: require("../assets/images/cake1.jpg"),

     
    },
    {
      src: require("../assets/images/cupcakes-with-candy-fillings-small-donuts-marble-background-high-quality-photo.jpg"),

    
    },
    {
      src: require("../assets/images/joseph-abeesh-pjTiVhrAmx4-unsplash.jpg"),

     
    },
    {
      src: require("../assets/images/yummy-little-cakes-with-raspberries-along-with-cookies-light-cake-biscuit-sweet-berry-bake-fruit.jpg"),

      
    },
  ];
  useEffect(() => {
    const selectedImage = templateImages[currentSlideIndex];
    if (selectedImage) {
      drawCanvasImageWithMessage(selectedImage.src);
    }
  }, [currentSlideIndex, templateImages]);

  const handleToggleTemplate = () => {
    setIsTemplateMode(!isTemplateMode);
  };

  const drawCanvasImageWithMessage = (imageSrc) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const img = new window.Image();
    img.crossOrigin = "anonymous"; // Just in case

    img.src = imageSrc;

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#FFF700";
      ctx.font = "bold 200px Poppins";
      ctx.textAlign = "center";
      // ctx.width = canvas.width - 40;
      ctx.textBaseline = "center";

      const lines = wrapText(ctx, templateMessage, canvas.width - 40);
      lines.forEach((line, i) => {
        ctx.fillText(line, canvas.width / 2, canvas.height - 80 + i * 40);
      });
    };
  };

  const handleCanvasGenerate = () => {
    if (!templateMessage.trim()) {
      message.warning("Please enter a message first.");
      return;
    }
    drawCanvasImageWithMessage();
  };

  const handleCanvasDownload = () => {
    const canvas = canvasRef.current;
    const link = document.createElement("a");
    link.download = "whatsapp_template.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  const wrapText = (ctx, text, maxWidth) => {
    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    words.forEach((word) => {
      const testLine = currentLine ? currentLine + " " + word : word;
      const width = ctx.measureText(testLine).width;
      if (width > maxWidth) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        currentLine = testLine;
      }
    });
    lines.push(currentLine);
    return lines;
  };


  const handleSendViaEmailOrWhatsApp = async () => {

    if (messageMode === "email") {
      handleSendMessage()
    }else if (messageMode === "mobile") {
      if (!mobileNumber.trim() && !selectedVoters.length > 0) {
        message.warning("Please enter a mobile number.");
        return;
      }
      console.log(selectedVoters, "selectedVoters",mobileNumber);

      
      
      const payload = {
        // mobileNumbers: selectAll ? [] : selectedVoters.map((voter) => voter.mobileNumber),
        // name: selectAll ? [] : selectedVoters.map((voter) => voter.name),
users:selectedVoters,
        to:selectedVoters.length>0 ? null : mobileNumber,
        message:UserMessage,
        isSelectAll: selectAll,
      };
      try {
        const response = await dataService.sendWhatsAppMessage(payload);
        if (response.success === true) {
          message.success("WhatsApp message sent successfully");
          setSelectedVoters([]);
          setMobileNumber("");
          setUserMessage("");
        } else {
          message.error("Failed to send WhatsApp message");
        }
      } catch (e) {
        message.error("Error sending WhatsApp message");
      }
    }


  }    
  
  const handleSend = () => {
    const currentSlide = carouselRef.current.innerSlider.state.currentSlide;
    console.log("Selected Template:", templateImages[currentSlide].name);
    sendBirthdayWish(templateImages[currentSlide].name);
  };

  const handleDobChange = (date, dateString) => {
    setDob(dateString);
  };

  // Function to toggle filters
  const handleFilterChange = (filterName) => {
    handlePageChange(1, 10);

    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: !prevFilters[filterName],
    }));
  };

  // Function to open the drawer
  const showDrawer = () => {
    setVisible(true);
  };

  // Function to close the drawer
  const onClose = () => {
    setVisible(false);
  };

  const getInfluencer = async () => {
    try {
      const res = await dataService.getInfluencers();
      if (res.code === 200) {
        setData(res.data);
        setFilteredData(res.data);
        setSelectedVoters(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleToggle = (checked) => {
    setIsInfluencer(checked);
    if (checked) {
      getInfluencer();
    } else {
      getUsers();
    }
  };

  const location = useLocation();

  const surveyData = location.state?.surveyData;

  const sendBirthdayWish = async (val) => {
    setLoading(true);
    const data = {
      voters: selectedVoters,
      template: val,
    };
    try {
      const res = await dataService.birthdayWish(data);
      if (res.code === 200) {
        message.success(res.message);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getUsers = async () => {
    try {
      setLoading(true);
      const res = await dataService.getAllUsers();
      if (res.code === 200) {
        setData(res.data);
        setFilteredData(res.data); // Ensure filteredData has initial data
      } else {
        message.error("Failed to fetch users");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while fetching users");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUsers();
  }, []);

  const handleSelectAll = () => {
    setselectAll(!selectAll);
    if (selectedVoters.length === filteredData.length) {
      setSelectedVoters([]);
    } else {
      setSelectedVoters(filteredData);
    }
  };

  // Handle voter selection
  const handleSelectVoter = (voter) => {
    setSelectedVoters((prevSelected) => {
      if (prevSelected.some((selected) => selected._id === voter._id)) {
        return prevSelected.filter((selected) => selected._id !== voter._id);
      }
      return [...prevSelected, voter];
    });
  };

  const handleSendMessage = async () => {
    let id;
    if (boothId && panchayatId && assemblyId) {
      id = {
        boothId: boothId,
      };
    } else if (panchayatId && assemblyId) {
      id = {
        panchayatId: panchayatId,
      };
    } else if (assemblyId) {
      id = {
        assemblyId: assemblyId,
      };
    } else {
      id = {};
    }
    console.log(selectedVoters, "selectedVoters");
    const payload = {
      voters: selectAll ? [] : selectedVoters?.map((voter) => voter._id),
      emailHeader,
      message: UserMessage,
      ...id,
      isSelectAll: selectAll,
    };
    try {
      const response = await dataService.sendMessage(payload);
      if (response.code === 200) {
        message.success("Email sent successfully");
        setSelectedVoters([]);
        setEmailHeader("");
        setMessages("");
      } else {
        message.error("Failed to send message");
      }
    } catch (e) {
      // message.error("Error sending message");
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = data.filter(
      (item) =>
        item?.firstName?.toLowerCase().includes(value) ||
        item?.epicNo?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const OnBoothSelect = (value) => {
    setBoothId(value);
    handlePageChange(1, 10);

    setelectionType("booth");
  };

  const OnAssemblySelect = async (value) => {
    handlePageChange(1, 10);

    setAssemblyId(value);
    setPanchayatId("");
    setBoothId("");
    setBoothList([]);
    setPanchayatList([]);
    setelectionType("assembly");
    try {
      const res = await dataService.getPanchayatFromAssembly({
        assembly: value,
      });
      if (res.code === 200) setPanchayatList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnPanchayatSelect = async (value) => {
    handlePageChange(1, 10);
    setPanchayatId(value);
    setBoothId("");
    setBoothList([]);
    setelectionType("panchayat");

    try {
      const res = await dataService.GetBooth({ panchayat: value });
      if (res.code === 200) setBoothList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnConstituencySelect = async (value) => {
    setConstituencyId(value);
    setAssemblyId("");
    setPanchayatId("");
    setBoothId("");
    setAssemblyList([]);
    setBoothList([]);
    setPanchayatList([]);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) setAssemblyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setConstituencyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (surveyData === undefined) {
    } else {
      setEmailHeader(`${surveyData.title} Link`);
      setMessages(
        `https://nirmalya.store/karyalay/survey-form/${surveyData._id}`
      );
    }
  }, []);

  const applyFilters = () => {
    getVoterListForMessage();
    setVisible(false);
  };

  const getVoterListForMessage = async () => {
    // const payload = { _id: boothId };
    const id =
      electionType === "assembly"
        ? assemblyId
        : electionType === "panchayat"
        ? panchayatId
        : electionType === "booth"
        ? boothId
        : constituencyId;

    setLoading(true);

    try {
      const res = await dataService.GetVotersMessage(
        data,
        id,
        skip,
        limit,
        electionType,
        selectedFilters.influencers,
        selectedFilters.dob,
        selectedFilters.hof
      );
      if (res.code === 200) {
        if (res?.data) {
          setData(res?.data);
          if (selectAll) {
            setSelectedVoters(res.data);
          }
          setFilteredData(res?.data);
          setTotalItems(res?.totalVoters);
        } else {
          message.error("No Voters Found");
        }
      }
    } catch (e) {
      message.error("Something went wrong");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getVoterLists = async () => {
    const payload = { _id: boothId };
    setLoading(true);

    try {
      const res = await dataService.GetVoters(
        data,
        constituencyId,
        skip,
        limit,
        "constituency"
      );
      if (res.code === 200) {
        if (res?.data) {
          setData(res?.data);
          setFilteredData(res?.data);
          setTotalItems(res?.totalVoters);
        } else {
          message.error("No Voters Found");
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page, pageSize) => {
    console.log(page, pageSize, "pp");
    setCurrentPage(page);
    setPageSize(pageSize);

    const skip = (page - 1) * pageSize;
    const limit = pageSize;

    setskip(skip);
    setlimit(limit);
  };

  useEffect(() => {
    if (constituencyId && assemblyId) {
      getVoterListForMessage();
    }
  }, [constituencyId, assemblyId, panchayatId, boothId, currentPage, pageSize]);

  useEffect(() => {
    getConstituency();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <Row gutter={[16, 16]} justify="center">
        {/* <Col xs={24} md={24} lg={18}>
          <div
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "20px" }}
          >
            <Select
              value={constituencyId}
              placeholder="Select Parliament"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{
                flex: "1 1 200px",
                margin: "5px",
                border: "1px solid #f5821f",
                borderRadius: 7,
              }}
              onChange={OnConstituencySelect}
            >
              <Option style={{
                color:colors.sidebarText
              }} key={827272} value="" disabled>
                Select Parliament
              </Option>
              {constituencyList.map((item) => (
                <Option  style={{
                  color:colors.sidebarText
                }} key={item._id} value={item._id}>
                  {item.constituencyName}
                </Option>
              ))}
            </Select>
            <Select
              value={assemblyId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Assembly"
              style={{
                flex: "1 1 200px",
                margin: "5px",
                border: "1px solid #f5821f",
                borderRadius: 7,
              }}
              onChange={OnAssemblySelect}
              disabled={!constituencyId}
            >
              <Option style={{
                  color:colors.sidebarText
                }}  key={827272} value="" disabled>
                Select Assembly
              </Option>
              {assemblyList.map((item) => (
                <Option style={{
                  color:colors.sidebarText
                }}  key={item._id} value={item._id}>
                  {item.assemblyName}
                </Option>
              ))}
            </Select>
            <Select
              value={panchayatId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Panchayat"
              style={{
                flex: "1 1 200px",
                margin: "5px",
                border: "1px solid #f5821f",
                borderRadius: 7,
              }}
              onChange={OnPanchayatSelect}
              disabled={!assemblyId}
            >
              <Option style={{
                  color:colors.sidebarText
                }}  key={827272} value="" disabled>
                Select Panchayat
              </Option>
              {panchayatList.map((item) => (
                <Option style={{
                  color:colors.sidebarText
                }}  key={item._id} value={item._id}>
                  {item.panchayatName}
                </Option>
              ))}
            </Select>
            <Select
              value={boothId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Booth"
              style={{
                flex: "1 1 200px",
                margin: "5px",
                border: "1px solid #f5821f",
                borderRadius: 7,
              }}
              onChange={OnBoothSelect}
              disabled={!panchayatId}
            >
              <Option style={{
                  color:colors.sidebarText
                }}  key={827272} value="" disabled>
                Select Booth
              </Option>
              {boothList.map((item) => (
                <Option style={{
                  color:colors.sidebarText
                }}  key={item._id} value={item._id}>
                  {item.boothNumber}
                </Option>
              ))}
            </Select>
          </div>
        </Col> */}

        <Col xs={24} md={12}>
          <Card
            style={{
              borderRadius: 10,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
            hoverable
          >
            <Row align="middle" justify="space-between">
              {/* Name Display */}
              <Col>
                {/* <Title level={4} style={{ margin: 0, color: "#1890ff" }}>
                  {isInfluencer ? "Influencer List" : "Voter List"}
                </Title> */}
                <Title
                  level={4}
                  style={{ margin: 0, color: colors.sidebarText }}
                >
                  Users Lists
                </Title>
              </Col>

              {/* Toggle Switch */}
              <Col>
                {/* <Switch
                  checked={isInfluencer}
                  onChange={handleToggle}
                  checkedChildren="Influencer"
                  unCheckedChildren="Voter"
                  style={{
                    backgroundColor: isInfluencer ? "#1890ff" : "#52c41a",
                  }}
                /> */}
                {boothId && (
                  <Button
                    type="primary"
                    style={{
                      // position: "absolute",
                      // top: 10,
                      // right: 10,
                      // borderRadius: 5,
                      fontWeight: "bold",
                    }}
                    onClick={showDrawer}
                  >
                    Filter
                  </Button>
                )}
              </Col>
            </Row>

            {/* Description */}
            {/* <Text type="secondary" style={{ display: "block", marginTop: 15 }}>
              Toggle to switch between Influencer and Voter.
            </Text> */}
          </Card>
          <Card bordered>
            <Input
              placeholder="Search voters by name or number"
              value={searchTerm}
              onChange={handleSearch}
              style={{ marginBottom: "15px" }}
            />
            <Checkbox
              checked={
                selectedVoters.length === filteredData.length
              }
              onChange={handleSelectAll}
              style={{ marginBottom: "10px" }}
            >
              Select Users
            </Checkbox>
            <Spin spinning={loading}>
              <List
                dataSource={filteredData}
                renderItem={(item) => (
                  <List.Item key={item._id}>
                  <Checkbox
                    checked={selectedVoters.some((voter) => voter._id === item._id)}
                    onChange={() => handleSelectVoter(item)}
                    style={{ width: "100%" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        alignItems: "center",
                        padding: "8px 12px",
                        border: "1px solid #f0f0f0",
                        borderRadius: 6,
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <div style={{ flexDirection: "row" }}>
                        <Text strong>{item.name}</Text>
                        {/* <br /> */} &nbsp;
                        {/* <br /> */} &nbsp;
                        {/* <br /> */} &nbsp;
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          {item.email}
                        </Text>
                        {/* <br /> */} &nbsp;
                        {/* <br /> */} &nbsp;
                        {/* <br /> */} &nbsp;
                        {/* <br /> */}
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          {item.mobileNumber}
                        </Text>
                      </div>
                    </div>
                  </Checkbox>
                </List.Item>
                
                )}
                // pagination={true}
                style={{ maxHeight: "300px", overflowY: "auto" }}
              />
            </Spin>

            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalItems}
              onChange={handlePageChange}
              style={{ marginTop: "16px", textAlign: "center" }}
            />
          </Card>
        </Col>
        {/* <Col xs={24} md={12}>
          <Card title="Send Message" bordered>
            <Input
              placeholder="Enter Email Header"
              value={emailHeader}
              onChange={(e) => setEmailHeader(e.target.value)}
              style={{ marginBottom: "10px" }}
            />
            <TextArea
              placeholder="Enter your message"
              value={messages}
              onChange={(e) => setMessages(e.target.value)}
              rows={4}
              style={{ marginBottom: "10px" }}
            />
            <Button
              type="primary"
              icon={<AiOutlineMessage />}
              onClick={handleSendMessage}
              disabled={selectedVoters.length === 0}
              block
              style={{ marginBottom: "10px" }}
            >
              Send Email
            </Button>
            <Button
              type="default"
              icon={<FaWhatsapp />}
              block
              disabled={selectedVoters.length === 0}
            >
              Send via WhatsApp
            </Button>
          </Card>
        </Col> */}
        <Col xs={24} md={12}>
          <Card
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  {isTemplateMode ? "Birthday Template" : "Send Message"}
                </span>
                <Switch
                  checked={isTemplateMode}
                  onChange={handleToggleTemplate}
                  checkedChildren="Template"
                  unCheckedChildren="Message"
                />
              </div>
            }
            bordered
          >
            {isTemplateMode ? (
              <div style={{}}>
                <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "16px",
    marginBottom: "20px",
  }}
>
  {templateImages.map((image, index) => (
    <div key={index} style={{ textAlign: "center" }}>
      <img
        src={image.src}
        alt={image.name}
        style={{
          width: "100%",
          height: "150px",
          objectFit: "cover",
          borderRadius: "8px",
          border: currentSlideIndex === index ? "3px solid #52c41a" : "1px solid #ccc",
          cursor: "pointer",
        }}
        onClick={() => {
          setCurrentSlideIndex(index);
          drawCanvasImageWithMessage(image.src);
        }}
      />
      <div style={{ marginTop: 8 }}>{image.name}</div>
    </div>
  ))}
</div>

                <div style={{ textAlign: "center", marginTop: "10px" }}>
                <TextArea
                  placeholder="Write message for canvas"
                  value={templateMessage}
                  onChange={(e) => setTemplateMessage(e.target.value)}
                  rows={3}
                  style={{ margin: "10px 0" }}
                />
                </div>
                {/* CANVAS */}
                <div style={{ textAlign: "center", marginBottom: "10px" }}>
                  <canvas
                    ref={canvasRef}
                    width={100}
                    height={100}
                    style={{
                      border: "1px solid #ccc",
                      maxWidth: "50%",
                      borderRadius: "10px",
                    }}
                  />
                </div>

                {/* Buttons for Manual Control */}
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}
                >
                  <Button
                    onClick={() => carouselRef.current.prev()}
                    style={{ backgroundColor: "#1890ff", color: "#fff" }}
                  >
                    Previous
                  </Button>
                  <Button
                    onClick={() => carouselRef.current.next()}
                    style={{ backgroundColor: "#1890ff", color: "#fff" }}
                  >
                    Next
                  </Button>
                </div> */}

                {/* Send Button */}
              <div>
                  <Button
                  type="primary"
                  block
                  onClick={handleSend}
                  style={{
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                    color: "#fff",
                    marginBottom: 10,
                  }}
                >
                  Send
                </Button>
                <Button
                  type="primary"
                  block
                  onClick={handleCanvasGenerate}
                  style={{
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                    marginBottom: 10,
                  }}
                >
                  Generate Image with Message
                </Button>
                <Button
                  type="default"
                  block
                  onClick={handleCanvasDownload}
                  icon={<FaWhatsapp />}
                >
                  Download & Send via WhatsApp
                </Button>
              </div>
              </div>
            ) : (
              <>


<div>
      {/* Toggle Email / Mobile */}
      <Radio.Group
        value={messageMode}
        onChange={(e) => setMessageMode(e.target.value)}
        style={{ marginBottom: 16 }}
        optionType="button"
        buttonStyle="solid"
      >
        <Radio.Button value="email">Email</Radio.Button>
        <Radio.Button value="mobile">Mobile</Radio.Button>
      </Radio.Group>

      {/* Email Fields */}
      {messageMode === "email" && (
        <Input
          placeholder="Enter Email Header"
          value={emailHeader}
          onChange={(e) => setEmailHeader(e.target.value)}
          style={{ marginBottom: 10 }}
        />
      )}

      {/* Mobile Fields */}
      {messageMode === "mobile" && (
        <Input
          placeholder={ !selectedVoters?.length ? `Enter Mobile Number`: "Selected users will receive WhatsApp message"}
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          style={{ marginBottom: 10 }}
          maxLength={10}
          disabled={selectedVoters?.length > 0 ? true : false}
        />
      )}

      {/* Shared Message Input */}
      <TextArea
        placeholder={`Enter your ${messageMode === "email" ? "email" : "WhatsApp"} message`}
        value={UserMessage}
        onChange={(e) => setUserMessage(e.target.value)}
        rows={4}
        style={{ marginBottom: 10 }}
      />

      {/* Send Button */}
      <Button
        type="primary"
        icon={messageMode === "email" ? <AiOutlineMessage /> : <FaWhatsapp />}
        onClick={handleSendViaEmailOrWhatsApp}
      
        block
        style={{
          marginBottom: 10,
          background:
            messageMode === "email"
              ? colors?.background || "#1890ff"
              : "#25D366",
          color: "#fff",
        }}
      >
        {messageMode === "email" ? "Send Email" : "Send via WhatsApp"}
      </Button>
    </div>


                {/* <Input
                  placeholder="Enter Email Header"
                  value={emailHeader}
                  onChange={(e) => setEmailHeader(e.target.value)}
                  style={{ marginBottom: "10px" }}
                />
                <TextArea
                  placeholder="Enter your message"
                  value={messages}
                  onChange={(e) => setMessages(e.target.value)}
                  rows={4}
                  style={{ marginBottom: "10px" }}
                />
                <Button
                  type="primary"
                  icon={<AiOutlineMessage />}
                  onClick={handleSendMessage}
                  disabled={selectedVoters.length === 0}
                  block
                  style={{
                    marginBottom: "10px",
                    background: colors.background,
                  }}
                >
                  Send Email
                </Button>
                <Button
                  type="default"
                  icon={<FaWhatsapp />}
                  block
                  disabled={selectedVoters.length === 0}
                  style={{
                    color: colors.sidebarText,
                  }}
                >
                  Send via WhatsApp
                </Button> */}
              </>
            )}
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} justify="center" style={{ marginTop: "20px" }}>
        <Col xs={24}>
          <Card title="Selected Users" style={{ color: colors.sidebarText }}>
            <List
              dataSource={selectedVoters}
              renderItem={(item) => (
                <List.Item key={item._id}>
             
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      alignItems: "center",
                      padding: "8px 12px",
                      border: "1px solid #f0f0f0",
                      borderRadius: 6,
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <div style={{ flexDirection: "row" }}>
                      <Text strong>{item.name}</Text>
                      {/* <br /> */} &nbsp;
                      {/* <br /> */} &nbsp;
                      {/* <br /> */} &nbsp;
                      <Text type="secondary" style={{ fontSize: "12px" }}>
                        {item.email}
                      </Text>
                      {/* <br /> */} &nbsp;
                      {/* <br /> */} &nbsp;
                      {/* <br /> */} &nbsp;
                      {/* <br /> */}
                      <Text type="secondary" style={{ fontSize: "12px" }}>
                        {item.mobileNumber}
                      </Text>
                    </div>
                  </div>
              </List.Item>
              )}
              style={{ maxHeight: "300px", overflowY: "auto" }}
            />
          </Card>
        </Col>
      </Row>
      {/* Ant Design Drawer for Side Filter */}
      <Drawer
        title="Filter Options"
        placement="left" // Can be "right" for right side filter
        width={300}
        onClose={onClose}
        visible={visible}
      >
        {/* Filter Options */}
        <Card
          style={{
            borderRadius: 10,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            marginBottom: 20,
          }}
        >
          <Row gutter={[16, 16]}>
            {/* Voters Checkbox */}
            <Col span={24}>
              <Checkbox
                checked={selectedFilters.voters}
                onChange={() => handleFilterChange("voters")}
              >
                All Users
              </Checkbox>
            </Col>

            {/* Influencers Checkbox */}
            <Col span={24}>
              <Checkbox
                checked={selectedFilters.influencers}
                onChange={() => handleFilterChange("influencers")}
              >
                Influencers
              </Checkbox>
            </Col>

            <Col span={24}>
              <Checkbox
                checked={selectedFilters.dob}
                onChange={() => handleFilterChange("dob")}
              >
                DOB
              </Checkbox>
            </Col>

            <Col span={24}>
              <Checkbox
                checked={selectedFilters.hof}
                onChange={() => handleFilterChange("hof")}
              >
                Head of Family
              </Checkbox>
            </Col>
          </Row>
        </Card>
        <Button
          onClick={applyFilters}
          style={{ position: "absolute", right: 20 }}
        >
          Apply
        </Button>
      </Drawer>
    </div>
  );
};

export default SendMessage;
